import { Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	imagePromotionSX,
	titlePromotionSX,
	linkPromotionSX,
} from '@/components/blocks/DpLibrary/DpPromotionImage/styles/main';
import { Linkable } from '@/components/blocks/Linkable';

export const DpPromotionImage = ({
	title,
	link,
	url,
	image,
	priority,
}: {
	title: string;
	link: string;
	url: string;
	image: string;
	priority?: boolean;
}) => (
	<>
		<Linkable href={url}>
			<Img src={image} sx={imagePromotionSX} priority={priority} />
		</Linkable>
		<Typography component="h3" sx={titlePromotionSX}>
			{' '}
			{title}{' '}
		</Typography>
		<Linkable href={url} type="inline" sx={linkPromotionSX}>
			{link}
		</Linkable>
	</>
);
